module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"logout":"Выйти"}}')
  delete Component.options._Ctor
}
